import "./styles.css";
import "./logo-motion.css";
import { createAnimatedLogo } from "./logo-motion";
import studioLogo from "./assets/web/sefidel-logo-200.png";
import animatedStudioLogo from "./assets/web/sefidel-logo-square-white-640.webp";
import multiplayerIndicator from "./assets/web/multiplayer-indicator-200.png";
import ghostsLogo from "./assets/web/games/ghosts-in-the-hood-logo-200.png";
import beaksLogo from "./assets/web/games/beaks-vs-broomsticks-logo-200.png";
import abductorsLogo from "./assets/web/games/alien-animal-abductors-logo-200.png";
import karensLogo from "./assets/web/games/clash-of-karens-logo-200.png";
import smallTownSingleMomLogo from "./assets/web/games/small-town-single-mom-logo-200.png";
import lazyLunchLadyLogo from "./assets/web/games/lazy-lunch-lady-logo-200.png";
import bedbugBashLogo from "./assets/web/games/bedbug-bash-logo-200.png";
import poopRacerLogo from "./assets/web/games/poop-racer-logo-200.png";
import cafeNervosaLogo from "./assets/web/games/cafe-nervosa-logo-transparent-200.png";
import lostTribesOfIsraelLogo from "./assets/web/games/lost-tribes-of-israel-logo-200.png";
import frostFighterLogo from "./assets/web/games/frost-fighter-logo-200.png";
import trashOrTreasureLogo from "./assets/web/games/trash-or-treasure-logo-200.png";
import poisonPickleLogo from "./assets/web/games/poison-pickle-logo-200.png";
import cSuiteSimulatorLogo from "./assets/web/games/c-suite-simulator-logo-200.png";
import escapeFromSeattleLogo from "./assets/web/games/escape-from-seattle-logo-200.png";
import wokeTrashBattleChessLogo from "./assets/web/games/woke-trash-battle-chess-logo-300.png";
import waifuWantsWafflesLogo from "./assets/web/games/waifu-wants-waffles-logo-300.png";
import communistComradesLogo from "./assets/web/games/communist-comrades-logo-300.png";
import breedersLogo from "./assets/web/games/breeders-logo-600.png";
import sandwichMakerPuzzleLogo from "./assets/web/games/sandwich-maker-puzzle-logo-400.png";

import witchRaceDerbyLogo from "./assets/web/games/witch-race-derby-logo-300.png";

const logo = document.querySelector("[data-studio-logo]");
const year = document.querySelector("[data-current-year]");

if (logo) {
  logo.src = studioLogo;
}

const animatedLogo = document.querySelector('[data-animated-studio-logo]');
if (animatedLogo) {
  createAnimatedLogo(animatedLogo, { source: animatedStudioLogo, controls: false });
}

const gameLogos = {
  witchRaceDerby: witchRaceDerbyLogo,
  waifuWantsWaffles: waifuWantsWafflesLogo,
  communistComrades: communistComradesLogo,
  breeders: breedersLogo,
  sandwichMakerPuzzle: sandwichMakerPuzzleLogo,
  ghosts: ghostsLogo,
  beaks: beaksLogo,
  abductors: abductorsLogo,
  karens: karensLogo,
  smallTownSingleMom: smallTownSingleMomLogo,
  lazyLunchLady: lazyLunchLadyLogo,
  bedbugBash: bedbugBashLogo,
  poopRacer: poopRacerLogo,
  cafeNervosa: cafeNervosaLogo,
  lostTribesOfIsrael: lostTribesOfIsraelLogo,
  frostFighter: frostFighterLogo,
  trashOrTreasure: trashOrTreasureLogo,
  poisonPickle: poisonPickleLogo,
  cSuiteSimulator: cSuiteSimulatorLogo,
  escapeFromSeattle: escapeFromSeattleLogo,
  wokeTrashBattleChess: wokeTrashBattleChessLogo,
};

document.querySelectorAll("[data-game-logo]").forEach((gameLogo) => {
  const source = gameLogos[gameLogo.dataset.gameLogo];

  if (source) {
    gameLogo.src = source;
  }
});

document.querySelectorAll("[data-multiplayer-indicator]").forEach((indicator) => {
  indicator.src = multiplayerIndicator;
});

document.querySelectorAll("[data-small-town-single-mom-logo]").forEach((gameLogo) => {
  gameLogo.src = smallTownSingleMomLogo;
});

if (year) {
  year.textContent = new Date().getFullYear();
}

const gameCards = document.querySelectorAll("[data-game-card]");
const gameDialog = document.querySelector("[data-game-dialog]");

if (gameCards.length && gameDialog) {
  const modalTitle = gameDialog.querySelector("[data-game-title]");
  const modalDate = gameDialog.querySelector("[data-game-date]");
  const modalDescription = gameDialog.querySelector("[data-game-description]");
  const videoFrame = gameDialog.querySelector("[data-video-frame]");
  const videoPlaceholder = gameDialog.querySelector("[data-video-placeholder]");
  const closeButton = gameDialog.querySelector("[data-modal-close]");
  let activeCard;

  const closeModal = () => {
    if (gameDialog.open) {
      gameDialog.close();
    }
  };

  gameCards.forEach((card) => {
    card.addEventListener("click", () => {
      const title = card.querySelector("h3")?.textContent || "Unannounced";
      const releaseDate = card.querySelector(".game-date")?.textContent || "TBA";
      const youtubeId = card.dataset.youtubeId?.trim();

      activeCard = card;
      modalTitle.textContent = title;
      modalDate.textContent = `Target release ${releaseDate}`;
      modalDescription.value = card.dataset.description || "Description coming soon.";

      if (youtubeId && /^[\w-]{11}$/.test(youtubeId)) {
        videoFrame.src = `https://www.youtube-nocookie.com/embed/${youtubeId}`;
        videoFrame.hidden = false;
        videoPlaceholder.hidden = true;
      } else {
        videoFrame.removeAttribute("src");
        videoFrame.hidden = true;
        videoPlaceholder.hidden = false;
      }

      gameDialog.showModal();
      document.body.classList.add("modal-open");
      closeButton.focus();
    });
  });

  closeButton.addEventListener("click", closeModal);

  gameDialog.addEventListener("click", (event) => {
    if (event.target === gameDialog) {
      closeModal();
    }
  });

  gameDialog.addEventListener("close", () => {
    videoFrame.removeAttribute("src");
    document.body.classList.remove("modal-open");
    activeCard?.focus();
  });
}
